import { render, staticRenderFns } from "./communityIntegralList.vue?vue&type=template&id=aae341f4&scoped=true"
import script from "./communityIntegralList.vue?vue&type=script&lang=js"
export * from "./communityIntegralList.vue?vue&type=script&lang=js"
import style0 from "./communityIntegralList.vue?vue&type=style&index=0&id=aae341f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae341f4",
  null
  
)

export default component.exports